import jsPDF from "jspdf";

export const downloadScriptAsPdf = (title: string, text: string) => {
  const doc = new jsPDF();

  const PAGE_HEIGHT = doc.internal.pageSize.height;
  const PAGE_WIDTH = doc.internal.pageSize.width;

  const TOP_MARGIN = 20;
  const LEFT_MARGIN = 20;
  const RIGHT_MARGIN = 20;
  const BOTTOM_MARGIN = 20;
  const FOOTER_HEIGHT = 10;

  /* -------------------- Meta -------------------- */
  doc.setProperties({
    title,
    subject: "Video Script",
    author: "Generated by PassionBits",
    keywords: "video script",
    creator: "PassionBits App",
  });

  /* -------------------- Title -------------------- */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.text(title, LEFT_MARGIN, TOP_MARGIN);

  doc.setLineWidth(0.5);
  doc.line(
    LEFT_MARGIN,
    TOP_MARGIN + 5,
    PAGE_WIDTH - RIGHT_MARGIN,
    TOP_MARGIN + 5
  );

  /* -------------------- Date -------------------- */
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(
    `Date: ${new Date().toLocaleDateString()}`,
    LEFT_MARGIN,
    TOP_MARGIN + 15
  );

  /* -------------------- Content -------------------- */
  const startY = TOP_MARGIN + 30;
  const maxWidth = PAGE_WIDTH - LEFT_MARGIN - RIGHT_MARGIN;
  const wrapped = doc.splitTextToSize(text, maxWidth);

  let y = startY;
  const lineHeight = doc.getFontSize() * 1.2;
  const usableHeight = PAGE_HEIGHT - BOTTOM_MARGIN - FOOTER_HEIGHT;

  wrapped.forEach((line: string) => {
    if (y + lineHeight > usableHeight) {
      doc.addPage();
      y = TOP_MARGIN;
    }

    doc.text(line, LEFT_MARGIN, y);
    y += lineHeight;
  });

  /* -------------------- Footer -------------------- */
  let footerY = y + 10;

  if (footerY + FOOTER_HEIGHT > PAGE_HEIGHT) {
    doc.addPage();
    footerY = PAGE_HEIGHT - BOTTOM_MARGIN;
  }

  doc.setFontSize(10);
  doc.text("Generated by PassionBits", LEFT_MARGIN, footerY);

  /* -------------------- Save -------------------- */
  doc.save(`${title}.pdf`);
};
